module.exports = __webpack_public_path__ + "img/Twitch-Lounge-BG.8665e558.jpg";